import {Alert} from "./LoginResultRecord";
import {FPNetDate} from "@commons/types";
import {URIAndTrace} from "@commons/mapping/URIAndTrace";

export type UserClass = 'ADMIN' | 'ALIAS' | 'SUPER' | 'COMPANY_OPERATOR' | 'BRANCH_OPERATOR' | 'EMPLOYEE';

interface LivelloEditStatus {
    chiusura: number;
    apertura: number;
}

export interface UserCRUDRecord extends URIAndTrace {
    idOwner: number;
    idProfiloAccesso: number;
    userName: string;
    password: string;
    passwordExpired: boolean;
    passwordMaxAge: number;
    tokenMaxAge: number;
    passwordLastChanged: FPNetDate;
    ambitoConsigliato: string;
    emailNotificheWF: string;
    emailVerificata: 0 | 1 | 2; // 0 email nn verificata, 1 è stata inviata un email di verifica/attivazione, 2 email varificata
    cognome: string;
    nome: string;
    codiceFiscale: string;
    email: string;
    telefono: string;
    cellulare: string;
    presenze: LivelloEditStatus;
    BDE: LivelloEditStatus;
    livelloEditTabelle: number;
    idProfiloGiu: number;
    numTentativi: number;
    ultimoTentativo: FPNetDate;
    alert4PswExpiry: Alert;
    idUser: number;
    userClass: UserClass;
    enabled: boolean;
    idLevel: number;
}

export class UserCRUDRecord {
    static getSesso = (user?: UserCRUDRecord | null): 'F' | 'M' => {
        if (user && user.codiceFiscale) {
            if (Number(user.codiceFiscale[9]) > 3) {
                return 'F';
            } else {
                return 'M';
            }
        }
        return 'M';
    };
}

export type UserProfileFormData = Pick<UserCRUDRecord, 'userName' | 'codiceFiscale' | 'nome' | 'cognome' | 'email' | 'telefono' | 'cellulare' | 'emailNotificheWF'>
